import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs, useLabels, useFlags } from 'wsm-common-data';
import PaymentSelector from './PaymentSelector';
import SpecialsDisplay from './SpecialsDisplay';
import StepCtas from './StepCtas';
import useUdsLeadGate from '../hooks/useUdsLeadGate';
import usePaymentData from '../hooks/usePaymentData';
import { UDS_LEAD_GATE, CTA_DISPLAY } from '../constants';

import './PaymentSelector.scss';

const UdsLeadGateOverlay = ({ text = '' }) => {
	const handleClick = (e) => {
		e.preventDefault();
		document.getElementById('mmd-widget')?.scrollIntoView({ behavior: 'smooth' });
	};

	return (
		<div className="payment-unavailable">
			<div className="payment-unavailable-content">
				<p className="payment-unavailable-title">
					<a
						href="#mmd-widget"
						aria-label={text}
						role="button"
						onClick={handleClick}
					>
						{text}
					</a>
				</p>
			</div>
		</div>
	);
};

const PaymentSelectorView = () => {
	const labels = useLabels();
	const { enableIncentives, showCTAs, ctaDisplay } = usePrefs();
	const isLeadGateActive = useUdsLeadGate();
	const [isLoading, hasError, paymentData] = usePaymentData();
	const flags = useFlags();
	const isTestFutureEnabled = flags['ws-track-my-offer-test-future'] || false;

	const effectiveCtaDisplay = isTestFutureEnabled
		? (ctaDisplay || CTA_DISPLAY.DEFAULT)
		: CTA_DISPLAY.DEFAULT;

	// ctaDisplay=none takes priority over showCTAs (only when feature flag is enabled)
	const shouldShowCTAs = isTestFutureEnabled
		? (effectiveCtaDisplay !== CTA_DISPLAY.NONE && showCTAs === 'true')
		: showCTAs === 'true';

	return (
		<>{isLeadGateActive
			?
				<UdsLeadGateOverlay text={labels.get(UDS_LEAD_GATE)} />
			:
				<>
					<PaymentSelector
						key="track-my-offer-payment-selector"
						isLoading={isLoading}
						hasError={hasError}
						paymentData={paymentData}
					/>
					{enableIncentives === 'true' && (
						<SpecialsDisplay
							key="track-my-offer-specials-display"
							isLoading={isLoading}
							hasError={hasError}
							paymentData={paymentData} 
						/>
					)}
					{shouldShowCTAs && (
					<StepCtas
						key="track-my-offer-ctas"
						ctaDisplay={effectiveCtaDisplay}
					/>
				)}
				</>
			}
		</>
	);
};


UdsLeadGateOverlay.propTypes = {
	text: PropTypes.string
};

export default PaymentSelectorView;